import React from "react"
import { Link } from "react-router-dom";
export default function Nav(props) {
    const [cartLengthState, changeCartSize] = React.useState(JSON.parse(localStorage.getItem("cart")) ? JSON.parse(localStorage.getItem("cart")).length : 0)
    
    window.addEventListener('cart2', () => {
        changeCartSize(JSON.parse(localStorage.getItem("cart")).length)
    })

    return (
        <>
            <nav>
                <div className="navSideOne navSide">
                    <Link to="/menu" className="navSideOneTextOne navText">Menu</Link>
                    <Link to="/contact" className="navSideOneTextTwo navText">Contact Us</Link>
                </div>
                <Link to="/">
                    <img src="logo.png" alt="logo" className="navLogo" onClick={props.changeDropdownUp} />
                </Link>
               
                <div className="navSideTwo navSide">
                    <Link to="/about" className="navSideTwoTextOne navText">About Us</Link>
                    <Link to="/cart" className="navCart">
                        <svg width="47" height="38" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 31.7925V12.5C1 9.73858 3.23858 7.5 6 7.5H41C43.7614 7.5 46 9.73857 46 12.5V31.7925C46 34.5539 43.7614 36.7925 41 36.7925H6C3.23858 36.7925 1 34.5539 1 31.7925Z" stroke="#DDDDDD" strokeWidth="2"/>
                            <path d="M13.5 8C16.3931 2.71764 24.4434 -4.67767 33.5 8" stroke="#DDDDDD" strokeWidth="2"/>
                        </svg>
                        <p>{cartLengthState}</p>
                    </Link>
                </div>
                {!props.dropdownState ? <i className="fa-solid fa-bars navBars" onClick={props.changeDropdownState}></i> : <i className="fa-solid fa-x navBars" onClick={props.changeDropdownState}></i>}
            </nav>
            <div className="dropdownContainer">
                <div className={props.dropdownState ? "dropdown dropdownOpen" : "dropdown dropdownClosed"}>
                    <Link to="/cart" className="dropdownCart" onClick={props.changeDropdownState}>
                        <svg width="47" height="38" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 31.7925V12.5C1 9.73858 3.23858 7.5 6 7.5H41C43.7614 7.5 46 9.73857 46 12.5V31.7925C46 34.5539 43.7614 36.7925 41 36.7925H6C3.23858 36.7925 1 34.5539 1 31.7925Z" stroke="#DDDDDD" strokeWidth="2"/>
                            <path d="M13.5 8C16.3931 2.71764 24.4434 -4.67767 33.5 8" stroke="#DDDDDD" strokeWidth="2"/>
                        </svg>
                        <p>{cartLengthState}</p>
                    </Link>
                    <div className="dropdownElements">
                        <Link to="/menu" className="dropdownElement" onClick={props.changeDropdownState}>
                            <div className="dropdownElementText">Menu</div>
                        </Link>
                        <Link to="/contact" className="dropdownElement" onClick={props.changeDropdownState}>
                            <div className="dropdownElementText">Contact Us</div>
                        </Link>
                        <Link to="/about" className="dropdownElement" onClick={props.changeDropdownState}>
                            <div className="dropdownElementText">About Us</div>
                        </Link>
                    </div>
                </div>
            </div>
        </>
        
    )
}